import { useEffect } from 'react';
import { prepareLanguagePreference } from '../lib/translation';

const hostId = 'jil-id-gt-191';
const scriptId = 'google-translate-element-js-7391';

function initializeTranslator() {
  const host = document.getElementById(hostId);
  const TranslateElement = window.google?.translate?.TranslateElement;
  if (!host || !TranslateElement || host.dataset.initialized || host.querySelector('.goog-te-combo')) return;
  host.dataset.initialized = 'true';
  try {
    new TranslateElement({ pageLanguage: 'en', includedLanguages: 'en,es,ko,ar,ml', autoDisplay: false }, hostId);
    host.querySelectorAll('*').forEach((el, index) => { el.dataset.testid = `translate-widget-${index}`; });
  } catch {
    delete host.dataset.initialized;
    console.warn('The original Google Translate service could not be initialized.');
  }
}

/** Google owns this DOM subtree. Keep it outside route elements for its lifetime. */
export const GoogleTranslator = () => {
  useEffect(() => {
    prepareLanguagePreference();
    window.jil_gt_init_7391 = initializeTranslator;
    if (window.google?.translate?.TranslateElement) initializeTranslator();
    else if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://translate.google.com/translate_a/element.js?cb=jil_gt_init_7391';
      script.async = true;
      script.addEventListener('error', () => console.warn('Google Translate could not be loaded.'), { once: true });
      document.body.appendChild(script);
    }
    // No route cleanup: the SDK has no supported destroy API and remains shared.
  }, []);

  return <div id={hostId} data-testid="google-translate-host" style={{ display: 'none' }} aria-hidden="true" />;
};